export default "__VITE_ASSET__D3FA2Rp2__"